import React, { useEffect, useState, useCallback } from 'react';
import { Button, Label, Icon } from '@iq/react-components';
import { useSelector } from 'react-redux';

import SimpleModal from '../SimpleModal';
import Indicator from '../panels/EventTimelinePanel/Indicator';

import { getTimezone } from '../../bundles/application';
import { formatSiteDatetime } from '../../datetimeUtils';
import { SEVERITIES, FORM_STATES } from '../../constants';

function showLabelledValue(value, label, transformer, showLabel = true, emptyValue = 'None') {
  if (!value && !showLabel) return null;
  let displayValue = emptyValue;
  if (value && (typeof value !== 'object' || value.length > 0)) {
    displayValue = transformer ? transformer(value) : value;
  }
  return (
    <>
      <Label>{label}</Label>
      <div className={`value-container ${displayValue === emptyValue ? 'empty-value' : ''}`}>
        {displayValue}
      </div>
    </>
  );
}

const getRenderValueList = (options = {}) => {
  const { inline = true, distinct = true } = options;
  return (values) => (
    <div className={`value-list ${inline ? 'inline' : ''}`}>
      {values.map((value, index) => (
        <div
          key={index}
          className={`value-list__value ${distinct ? 'distinct' : ''}`}
        >
          {value}
        </div>
      ))}
    </div>
  );
};

const DtmpEventModal = ({
  event: readOnlyEvent,
  hasHistory = false,
  onBack = () => null,
  onClose,
  componentName: passedComponentName,
}) => {
  const [event, setEvent] = useState(readOnlyEvent);

  useEffect(() => {
    setEvent(readOnlyEvent);
  }, [readOnlyEvent]);

  const {
    text,
    timestamp,
    severity,
    messageType,
    algorithmName,
    algorithmId,
    algorithmType,
    additionalIdentifier,
    recommendation,
  } = event;

  const timezone = useSelector(getTimezone);

  const handleClose = useCallback(() => {
    onClose({ refresh: false });
  }, [onClose]);

  if (!event?.timestamp) {
    return null;
  }

  return event?.timestamp ? (
    <SimpleModal
      size="l"
      onClose={handleClose}
      className={`event-modal-wrapper ${FORM_STATES.view}`}
      headerLeft={
        hasHistory ? (
          <Button
            design="text"
            tooltip="Back"
            onClick={onBack}
          >
            <Icon icon="he-previous" />
          </Button>
        ) : undefined
      }
      title={
        <div className="event-modal-header">
          <Indicator
            severity={severity}
            round={false}
            size={12}
          />
          <div>{text || 'DTMP Event'}</div>
        </div>
      }
    >
      <div className={`event-modal ${FORM_STATES.view}`}>
        <div className={`top-section`}>
          <div className={`top-section__content iot`}>
            <div className="event-modal__attribute-group">
              {showLabelledValue(algorithmName, 'Algorithm Name')}
            </div>
            <div className="event-modal__attribute-group">
              {showLabelledValue(algorithmType, 'Algorithm Type')}
            </div>
          </div>
        </div>
        <div className={`body-section iot`}>
          <div className="event-modal__column">
            <div className="event-modal__attribute-group">
              {showLabelledValue(formatSiteDatetime(timestamp, timezone, true), 'Timestamp')}
            </div>
            <div className="event-modal__attribute-group">
              {showLabelledValue(SEVERITIES[severity], 'Severity')}
            </div>
            <div className="event-modal__attribute-group">
              {showLabelledValue(messageType, 'Message Type')}
            </div>
          </div>
          <div className="event-modal__column">
            <div className="event-modal__attribute-group">
              {showLabelledValue(algorithmId, 'Algorithm ID')}
            </div>
            <div className="event-modal__attribute-group">
              {showLabelledValue(additionalIdentifier, 'Identifier')}
            </div>
            <div className="event-modal__attribute-group">
              {showLabelledValue(passedComponentName, 'Component')}
            </div>
            <div className="event-modal__attribute-group">
              {showLabelledValue(
                recommendation,
                'Recommendation',
                undefined,
                true,
                'No recommendation'
              )}
            </div>
          </div>
        </div>
      </div>
    </SimpleModal>
  ) : null;
};

export default DtmpEventModal;
